import React from "react";
import { Link } from "react-router-dom";

import star from "src/assets/images/star.png";
import classes from "./MovieItem.module.css";

import { Movie } from "src/types/movieData";
import { omitWhiteSpace } from "src/utility";

type Props = {
  movieData: Movie;
};

const MovieItem = ({ movieData }: Props) => {
  const movieTitle = omitWhiteSpace(movieData.title);

  return (
    <div className={classes.movieItem}>
      <div className={classes.ratingBadge}>
        <span className={classes.rating}>
          {Math.round(movieData.vote_average)}
        </span>
        <img src={star} alt="rating star" className={classes.star}></img>
      </div>
      <Link to={`movieDetail/${movieData.id}/${movieTitle}`}>
        <img
          src={`https://image.tmdb.org/t/p/w500/${movieData.poster_path}`}
          alt={classes.title}
          width={234}
          height={330}
          className={classes.poster}
        />
      </Link>
      <div className={classes.movieInfo}>
        <Link
          to={`movieDetail/${movieData.id}/${movieTitle}`}
          className={classes.title}
        >
          {movieData.title}
        </Link>
      </div>
    </div>
  );
};

export default MovieItem;
